import React from 'react';
import { Trans, useTranslation } from '@gamiphy/react-i18n';
import { observer } from 'mobx-react';
import { Box, Button, Typography } from '@mui/material';
import { UnavowedPopup } from '@gamiphy/loyalty-station-desktop/components/popups/unavowed';
import { formatWelcomeGiftValue } from '@gamiphy/loyalty-station-desktop/components/cashback/utils';
import { AppWelcomeGiftStore } from '@gamiphy/loyalty-station-desktop/store/appWelcomeGift';

const NoDiscount: React.FC = () => {
  const [unavowedPopupOpen, setUnavowedPopupOpen] = React.useState(false);
  const { t } = useTranslation();

  return (
    <Box>
      <Typography fontSize={14}>
        <Trans
          i18nKey="welcomeGift.unlock.exclusive"
          defaults="Unlock an exclusive {{welcomeGift}} discount on your first purchase of {{minPurchaseAmount, currency}} or more!"
          values={{
            welcomeGift: AppWelcomeGiftStore.welcomeGift && formatWelcomeGiftValue(AppWelcomeGiftStore.welcomeGift),
            minPurchaseAmount: AppWelcomeGiftStore.welcomeGift?.minPurchaseAmount,
          }}
        />
      </Typography>
      <Button variant="contained" color="primary" fullWidth onClick={() => setUnavowedPopupOpen(true)} sx={{ mt: 2 }}>
        <Trans i18nKey="welcomeGift.unlockCoupon" defaults="Unlock coupon" />
      </Button>
      <UnavowedPopup
        open={unavowedPopupOpen}
        onClose={() => setUnavowedPopupOpen(false)}
        title={t('welcomeGift.signup', 'Sign up now to unlock an exclusive welcome gift!')}
      />
    </Box>
  );
};

export default observer(NoDiscount);
